import { useState, useEffect } from 'react';
import { getCurrentQualification, getTodayMidnight, getQualStatusInfo } from '../utils/date.js';

export default function QualificationsPage({ user, onSelect }) {
  const quals = user.qualifications || [];
  const today = getTodayMidnight();
  const [currentQual, setCurrentQual] = useState(null);

  // Compute the date-driven current qualification on mount / qual change
  useEffect(() => {
    if (quals.length === 0) return;
    const computed = getCurrentQualification(quals, today);
    if (computed) {
      setCurrentQual(computed);
      onSelect(computed);
    } else if (quals.length === 1) {
      // No date-driven current but only one option — auto-select it anyway
      setCurrentQual(quals[0]);
      onSelect(quals[0]);
    }
  }, [quals, today, onSelect]);

  if (quals.length === 0) {
    return <div className="card"><p style={{ marginTop: 0, color: '#2c3e50' }}>No qualifications found.</p></div>;
  }

  // Single qualification — auto-select and show status only
  if (quals.length === 1) {
    const info = getQualStatusInfo(quals[0], today);
    return (
      <div className="card">
        <h2 style={{ marginTop: 0 }}>{quals[0].name}</h2>
        <p className="muted" style={{ color: info.color, fontWeight: 600 }}>
          {info.label}
        </p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Select your qualification</h2>
      <p className="muted">Choose the qualification you are currently studying.</p>

      {quals.map((q, idx) => {
        const info = getQualStatusInfo(q, today);
        const isActive = q === currentQual;

        return (
          <button
            key={idx}
            onClick={() => onSelect(q)}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '16px 20px',
              marginBottom: idx < quals.length - 1 ? 8 : 0,
              border: `1px solid ${isActive ? 'var(--brand)' : 'var(--border)'}`,
              borderRadius: 8,
              background: isActive ? '#f0f4f8' : 'white',
              cursor: 'pointer',
              fontSize: 15,
              fontWeight: isActive ? 600 : 400,
              color: '#2c3e50',
            }}
          >
            <div style={{ marginBottom: 4 }}>{q.name}</div>
            {q.units && q.units.length > 0 && (
              <span className="muted">{q.units.length} units</span>
            )}
            <span style={{ float: 'right', fontSize: 12, color: info.color, fontWeight: 600 }}>
              {info.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
